<template>
  <div id="app-content" class="mdc-drawer-app-content flex-auto overflow-auto relative">
    <Header />
    <Main :mainImg="mainImg" />
    <SignatureCollection />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Main from "@/components/body/Main.vue";
import SignatureCollection from "@/components/body/SignatureCollection";
import Footer from "@/components/Footer.vue";
import { mapActions, mapState } from 'vuex';

export default {
  name: "Home",
  components: {
    Header,
    Main,
    SignatureCollection,
    Footer,
  },

  created: function () {
  },

  mounted: function () {
    // this.tl
    //   // The text on the main image
    //   .fromTo(
    //     ".caption",
    //     {
    //       y: 50,
    //       opacity: 0,
    //     },
    //     {
    //       y: 0,
    //       opacity: 1,
    //     }
    //   )
    //   // The CTA button
    //   .fromTo(
    //     ".caption + a",
    //     {
    //       opacity: 0,
    //     },
    //     {
    //       opacity: 1,
    //     }
    //   );

    // // Heading: Brands
    // this.tl.to("#brands .heading", {
    //   scrollTrigger: {
    //     trigger: ".hero",
    //     start: "bottom 70%",
    //     end: "top 30%",
    //     toggleActions: "play pause restart pause",
    //     scrub: 1,
    //   },
    //   scale: 1,
    //   opacity: 1,
    // });
    // this.tl.to("#brands li", {
    //   scrollTrigger: {
    //     trigger: "#brands .heading",
    //     start: "bottom 70%",
    //     end: "top 30%",
    //     toggleActions: "play pause restart pause",
    //     scrub: 1,
    //   },
    //   scale: 1,
    //   opacity: 1,
    // });

    // // GridTwoCol images
    // this.tl.to("#grid-two-col li", {
    //   scrollTrigger: {
    //     trigger: "#grid-two-col li",
    //     start: "top center",
    //     end: "bottom 15%",
    //     toggleActions: "play pause restart pause",
    //     scrub: 1,
    //   },
    //   scale: 1,
    //   opacity: 1,
    //   stagger: 0.3,
    // });
  },

  computed: {
    ...mapState({
      tl: state => state.globals.tl,
    }),
  },

  data: function () {
    return {
      mainImg: this.$store.state.pages.home.mainImg,
    };
  },
  methods: {
    ...mapActions({
    }),
  },
};
</script>

<style lang="scss">
:root {
  --v-anchor-base: #000;
}
</style>
